import { render } from "./ActionsMessageTable.vue?vue&type=template&id=7b98d09e&scoped=true"
import script from "./ActionsMessageTable.vue?vue&type=script&lang=js"
export * from "./ActionsMessageTable.vue?vue&type=script&lang=js"

import "./ActionsMessageTable.vue?vue&type=style&index=0&id=7b98d09e&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b98d09e"]])

export default __exports__